<template>
  <div class="content_main">
    <a-tabs default-active-key="a" @change="callback">
      <a-tab-pane key="a" tab="集团流程使用情况分析">
        <div class="content_main o_s">
          <div class="top">
            <a-range-picker
              v-model="time"
              style="margin-right: 10px; width: 260px"
              allowClear
              :disabled="singleDate?true:false"
              valueFormat="YYYY-MM-DD"
              @change="get_chart"
            />
            <a-date-picker :disabled-date="disabledDate" placeholder="具体日期" v-model="singleDate" @change="get_chart" :disabled="time.length?true:false" allowClear valueFormat="YYYY-MM-DD" style="margin-right: 10px; width: 140px" />
            <a-select
              placeholder="请选择公司"
              class="margin_self a_select_self"
              v-model="company"
              allowClear
              @change="handleChange"
            >
              <a-select-option :value="item.value" v-for="(item, idx) in companys" :key="idx"
                >{{ item.label }}
              </a-select-option>
            </a-select>
            <a-select
              @change="get_chart()"
              allowClear
              placeholder="请选择部门"
              :disabled="!company"
              v-model="dept"
              style="width: 120px; margin-right: 10px"
            >
              <a-select-option :value="item.value" v-for="(item, idx) in depts" :key="idx"
                >{{ item.label }}
              </a-select-option>
            </a-select>
            <a-select
              class="margin_self a_select_self"
              allowClear
              v-model="status"
              placeholder="流程状态"
              @change="get_chart"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option :value="index" v-for="(item, index) in status_apply" :key="index">
                {{ item.txt }}
              </a-select-option>
            </a-select>
            <a-input placeholder="最小耗时" v-model="durationStart" type="number" style="width: 100px" />
            <a-input-search
              style="width: 180px; margin-right: 10px"
              placeholder="最大耗时(小时)"
              v-model="hour"
			  type="number"
              enter-button
              @search="onSearch"
            />
          </div>
          <div class="box">
            <div class="test" id="test"></div>
            <div class="chart2" id="chart2"></div>
            <div class="chart2" id="chart3"></div>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="b" tab="各分公司流程使用情况分析">
        <div class="content_main o_s">
          <div class="top">
            <a-range-picker
              v-model="time2"
              style="margin-right: 10px; width: 260px"
              allowClear
              :disabled="singleDate2?true:false"
              valueFormat="YYYY-MM-DD"
              @change="get_chart2"
            />
            <a-date-picker :disabled-date="disabledDate" placeholder="具体日期" v-model="singleDate2" @change="get_chart2" :disabled="time2.length?true:false" allowClear valueFormat="YYYY-MM-DD" style="margin-right: 10px; width: 140px" />
            <a-select
              class="margin_self a_select_self"
              allowClear
              v-model="status2"
              placeholder="流程状态"
              @change="get_chart2"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option :value="index" v-for="(item, index) in status_apply" :key="index">
                {{ item.txt }}
              </a-select-option>
            </a-select>
            <a-select
              class="margin_self a_select_self"
              allowClear
              v-model="procDefKey"
              placeholder="流程名称"
              @change="get_chart2"
            >
              <a-select-option value="all">全部</a-select-option>
              <a-select-option :value="item.id" v-for="(item, index) in audits" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-input placeholder="最小耗时" v-model="durationStart2" type="number" style="width: 100px" />
            <a-input-search
              style="width: 180px; margin-right: 10px"
              placeholder="最大耗时(小时)"
              v-model="hour2"
			  type="number"
              enter-button
              @search="onSearch2"
            />
          </div>
          <div class="box">
            <div class="test" id="tab_chat1"></div>
            <div class="chart2" id="tab_chat2"></div>
            <div class="chart2" id="tab_chat3"></div>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import { list_count1, list_count2, get_audit_list } from '@/api/activiti'
import { returnDept } from '@/utils/unit_axios'
export default {
  data() {
    return {
      audits: [],
      time: [],
      status: undefined,
      company: undefined,
      singleDate:'',
      companys: [],
      dept: undefined,
      hour: '',
      durationStart: '',
      isFirst: 0,
      time2: [],
      status2: undefined,
      durationStart2: '',
      hour2: '',
      procDefKey: undefined,
      disabledDate2:''
    }
  },
  mounted() {
    returnDept((res) => {
      res.depts.unshift({
        children: [],
        key: 0,
        label: '所有公司',
        value: 0,
      })
      this.companys = res.depts
    })
    this.get_chart()
    this.get_lis()
  },
  methods: {
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf('day');
    },
    get_lis() {
      get_audit_list().then((res) => {
        this.audits = res.data
      })
    },
    get_chart() {
      var that = this
      if (this.time.length) {
        var s = new Date(this.time[0]).getTime()
        var e = new Date(this.time[1]).getTime()
      } else {
        var s = ''
        var e = ''
      }
      if (this.hour && this.durationStart) {
        if (this.hour < this.durationStart) {
          this.$message.warning('最大耗时不能小于最小耗时')
          return
        }
      }
      var duration = ''
      if (this.hour) {
        duration = this.hour * 3600000
      }
      var durationStart = ''
      if (this.durationStart) {
        durationStart = this.durationStart * 3600000
      }
      list_count1({
        status: this.status,
        startTime: s,
        endTime: e,
        companyId: this.company ? this.company : '',
        deptId: this.dept ? this.dept : '',
        duration: duration,
        durationStart: durationStart,
        singleDate:this.singleDate
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        var lis = res.data
        var names = []
        var vals = []
        var as = []
        lis.forEach((element) => {
          element['value'] = element.count
          names.push(element.name)
          vals.push(element.count)
          as.push(element.average.toFixed(2))
        })
        var dom = document.getElementById('test')
        var myChart = this.$echarts.init(dom)
        var option = {
          title: {
            text: '不同流程使用情况(次)',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)',
          },
          toolbox: {
            show: true,
            feature: {
              dataView: { show: true, readOnly: true },
            },
          },
          series: [
            {
              name: '流程占比',
              type: 'pie',
              radius: '50%',
              label: {
                show: true,
                fontSize: 12,
                align: 'left',
                formatter: '{b}({c})',
              },
              labelLine: {
                smooth: 0.2,
                length: 10,
                length2: 20,
              },
              data: lis,
            },
            {
              name: '流程占比',
              type: 'pie',
              radius: '50%',
              avoidLabelOverlap: true,
              label: {
                show: true,
                position: 'inner',
                fontSize: 10,
                align: 'left',
                formatter: '{d}%',
              },
              labelLine: {
                smooth: 0.2,
                length: 10,
                length2: 20,
              },
              data: lis,
            },
          ],
        }
        option && myChart.setOption(option)
        var dom1 = document.getElementById('chart2')
        var myChart2 = this.$echarts.init(dom1)
        var option2 = {
          title: {
            text: '不同流程使用情况(次)',
            left: 'left',
          },
          toolbox: {
            show: true,
            feature: {
              dataView: { show: true, readOnly: true },
            },
          },
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            type: 'category',
            data: names,
            axisLabel: {
              interval: 0,
              rotate: 40,
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              name: '使用情况',
              itemStyle: {
                color: function (params) {
                  //通过返回值的下标一一对应将颜色赋给柱子上
                  return that.colors2[params.dataIndex]
                },
              },
              label: {
                show: true,
                position: 'top',
              },
              barWidth: 20, //柱图宽度
              data: vals,
              type: 'bar',
            },
          ],
        }
        option2 && myChart2.setOption(option2)
        var dom2 = document.getElementById('chart3')
        var myChart3 = this.$echarts.init(dom2)
        var option3 = {
          title: {
            text: '各流程平均耗时(小时)',
            left: 'left',
          },
          toolbox: {
            show: true,
            feature: {
              dataView: { show: true, readOnly: true },
            },
          },
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            type: 'category',
            data: names,
            axisLabel: {
              interval: 0,
              rotate: 40,
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              name: '平均耗时',
              itemStyle: {
                color: function (params) {
                  //通过返回值的下标一一对应将颜色赋给柱子上
                  return that.colors2[params.dataIndex]
                },
              },
              label: {
                show: true,
                position: 'top',
              },
              barWidth: 20, //柱图宽度
              data: as,
              type: 'bar',
            },
          ],
        }
        option3 && myChart3.setOption(option3)
      })
    },
    handleChange() {
      this.companys.forEach((element) => {
        if (element.value == this.company) {
          this.depts = element.children
          this.get_chart()
        }
      })
    },
    onSearch() {
      this.get_chart()
    },
    callback(k) {
      if (k == 'b') {
        if (this.isFirst == 0) {
          this.get_chart2()
        }
      }
    },
    onSearch2() {
      this.get_chart2()
    },
    get_chart2() {
      var that = this
      if (this.time2.length) {
        var s = new Date(this.time2[0]).getTime()
        var e = new Date(this.time2[1]).getTime()
      } else {
        var s = ''
        var e = ''
      }
      if (this.hour2 && this.durationStart2) {
        if (this.hour2 < this.durationStart2) {
          this.$message.warning('最大耗时不能小于最小耗时')
          return
        }
      }
      var duration = ''
      if (this.hour2) {
        duration = this.hour2 * 3600000
      }
      var durationStart = ''
      if (this.durationStart2) {
        durationStart = this.durationStart2 * 3600000
      }
      list_count2({
        status: this.status2,
        startTime: s,
        endTime: e,
        duration: duration,
        durationStart: durationStart,
        procDefKey: this.procDefKey == 'all' ? '' : this.procDefKey,
        disabledDate:this.disabledDate2
      }).then((res) => {
        if (res.code != 200) {
          this.$message.error(res.msg)
          return
        }
        this.isFirst += 1
        var lis = res.data
        var names = []
        var vals = []
        var as = []
        lis.forEach((element) => {
          element['value'] = element.count
          names.push(element.name)
          vals.push(element.count)
          as.push(element.average.toFixed(2))
        })
        var dom = document.getElementById('tab_chat1')
        var myChart = this.$echarts.init(dom)
        var option = {
          title: {
            text: '各公司流程使用情况(次)',
            left: 'center',
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)',
          },
          toolbox: {
            show: true,
            feature: {
              dataView: { show: true, readOnly: true },
            },
          },
          series: [
            {
              name: '流程占比',
              type: 'pie',
              radius: '55%',
              data: lis,
              label: {
                show: true,
                fontSize: 12,
                align: 'left',
                formatter: '{b}({c})',
              },
              labelLine: {
                smooth: 0.2,
                length: 10,
                length2: 20,
              },
            },
            {
              name: '流程占比',
              type: 'pie',
              radius: '55%',
              data: lis,
              label: {
                show: true,
                position: 'inner',
                fontSize: 10,
                align: 'left',
                formatter: '{d}%',
              },
              labelLine: {
                //指示线状态
                show: false,
                smooth: 0.2,
                length: 10,
                length2: 20,
              },
            },
          ],
        }
        option && myChart.setOption(option)
        var dom2 = document.getElementById('tab_chat2')
        var myChart2 = this.$echarts.init(dom2)
        var option2 = {
          title: {
            text: '各公司流程使用情况(次)',
            left: 'left',
          },
          tooltip: {
            trigger: 'axis',
          },
          toolbox: {
            show: true,
            feature: {
              dataView: { show: true, readOnly: true },
            },
          },
          xAxis: {
            type: 'category',
            data: names,
            axisLabel: {
              interval: 0,
              rotate: 40,
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              name: '使用情况',
              itemStyle: {
                color: function (params) {
                  //通过返回值的下标一一对应将颜色赋给柱子上
                  return that.colors2[params.dataIndex]
                },
              },
              label: {
                show: true,
                position: 'top',
              },
              barWidth: 15, //柱图宽度
              data: vals,
              type: 'bar',
            },
          ],
        }
        option2 && myChart2.setOption(option2)
        var dom3 = document.getElementById('tab_chat3')
        var myChart3 = this.$echarts.init(dom3)
        var option3 = {
          title: {
            text: '各公司审批平均耗时(小时)',
            left: 'left',
          },
          tooltip: {
            trigger: 'axis',
          },
          toolbox: {
            show: true,
            feature: {
              dataView: { show: true, readOnly: true },
            },
          },
          xAxis: {
            type: 'category',
            data: names,
            axisLabel: {
              interval: 0,
              rotate: 40,
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              name: '平均耗时',
              itemStyle: {
                color: function (params) {
                  //通过返回值的下标一一对应将颜色赋给柱子上
                  return that.colors2[params.dataIndex]
                },
              },
              label: {
                show: true,
                position: 'top',
              },
              barWidth: 15, //柱图宽度
              data: as,
              type: 'bar',
            },
          ],
        }
        option3 && myChart3.setOption(option3)
      })
    },
  },
}
</script>
<style lang="less" scoped>
.top {
  width: 100%;
  float: left;
  margin-bottom: 15px;
  margin-top: 10px;

  .top_item {
    float: left;
    margin-right: 15px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    span {
      margin-right: 10px;
    }
  }
}
.box {
  width: 100%;
  float: left;
  height: 80%;
  .test {
    width: 40%;
    height: 100%;
    float: left;
  }
  .chart2 {
    width: 60%;
    height: 100%;
    float: left;
  }
}
</style>

